import { motion } from "framer-motion";
import { Smartphone, Wrench, ShieldCheck, MapPin, HandCoins } from "lucide-react";

const IMG = {
  iphone: "https://images.unsplash.com/photo-1726587912121-ea21fcc57ff8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  samsung: "https://images.unsplash.com/photo-1707438095940-1eee18e85400?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  repair: "https://images.pexels.com/photos/6755075/pexels-photo-6755075.jpeg?auto=compress&cs=tinysrgb&w=900",
};

const fade = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6, delay: d } });

export const Hero = ({ onBookRepair }) => (
  <section id="top" className="relative overflow-hidden bg-white" data-testid="hero-section">
    <div className="absolute inset-0 grid-dots opacity-50 [mask-image:linear-gradient(to_bottom,black,transparent)]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 pb-16 md:pb-24 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6">
        <motion.p {...fade(0)} className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] uppercase text-brand-600">
          <MapPin className="h-4 w-4" /> Market Square, Dungannon
        </motion.p>
        <motion.h1 {...fade(0.1)} className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.02] text-ink" data-testid="hero-heading">
          FONZ FIX4U – <span className="text-brand-600">MOBILE PHONE SALES &amp; REPAIRS</span>
        </motion.h1>
        <motion.p {...fade(0.2)} className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed max-w-xl" data-testid="hero-subheading">
          New & A+ Used iPhones, Samsung Phones, Tablets, Accessories & Professional Phone Repairs in Dungannon.
        </motion.p>
        <motion.div {...fade(0.3)} className="mt-8 flex flex-col sm:flex-row gap-3">
          <a href="#phones" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-600 px-8 py-4 font-display font-bold tracking-wide text-white shadow-lg shadow-brand-600/25 hover:bg-brand-700 hover:-translate-y-0.5 transition-[background-color,transform]" data-testid="hero-shop-phones-btn">
            <Smartphone className="h-5 w-5" /> SHOP PHONES
          </a>
          <button onClick={onBookRepair} className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-8 py-4 font-display font-bold tracking-wide text-white shadow-lg shadow-slate-900/20 hover:bg-slate-800 hover:-translate-y-0.5 transition-[background-color,transform]" data-testid="hero-book-repair-btn">
            <Wrench className="h-5 w-5" /> BOOK A REPAIR
          </button>
        </motion.div>
        <motion.ul {...fade(0.4)} className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-sm font-semibold text-slate-700">
          <li className="flex items-center gap-2"><HandCoins className="h-4 w-4 text-brand-600" /> Fair prices & honest advice</li>
          <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-brand-600" /> Local, friendly & trusted in Dungannon</li>
        </motion.ul>
      </div>
      <HeroCollage />
    </div>
  </section>
);

const HeroCollage = () => (
  <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.2 }} className="lg:col-span-6 grid grid-cols-2 gap-3 md:gap-4" data-testid="hero-collage">
    <figure className="relative row-span-2 rounded-3xl overflow-hidden bg-slate-100 min-h-[320px]">
      <img src={IMG.iphone} alt="Apple iPhones for sale" className="absolute inset-0 h-full w-full object-cover" />
      <figcaption className="absolute left-3 bottom-3 rounded-full bg-white/90 backdrop-blur px-4 py-2 text-xs font-bold text-slate-900">iPhones · New & A+ Used</figcaption>
    </figure>
    <figure className="relative rounded-3xl overflow-hidden bg-slate-100 aspect-[4/3]">
      <img src={IMG.samsung} alt="Samsung Galaxy phones for sale" className="absolute inset-0 h-full w-full object-cover" />
      <figcaption className="absolute left-3 bottom-3 rounded-full bg-white/90 backdrop-blur px-4 py-2 text-xs font-bold text-slate-900">Samsung Galaxy</figcaption>
    </figure>
    <figure className="relative rounded-3xl overflow-hidden bg-ink aspect-[4/3]">
      <img src={IMG.repair} alt="Phone screen repair in progress" className="h-full w-full object-cover opacity-90" />
      <figcaption className="absolute left-3 bottom-3 rounded-full bg-brand-600 px-4 py-2 text-xs font-bold text-white">Phone Repairs</figcaption>
    </figure>
  </motion.div>
);
